export const findGeofenceMarker = (
  markers: Record<string, uui.domain.ui.map.markers.Geofence>,
  geofenceId: string,
): uui.domain.ui.map.markers.Geofence | undefined => {
  const marker = markers[geofenceId]

  return marker
}
